export default __webpack_public_path__ + "static/media/logo.b849f6a4.svg";